import * as React from 'react';
import './Spinner.scss';
export var Spinner = function (_a) {
    var classes = _a.classes;
    return (React.createElement("div", { className: "tiers-spinner ".concat(classes || '') },
        React.createElement("div", { className: "hd-coverup fade-in" },
            React.createElement("div", { className: "tiers-pre-loader" },
                React.createElement("div", { className: "tiers-segment-spinner" })))));
};
export var CopyButtonSpinner = function (_a) {
    var classes = _a.classes;
    return (React.createElement("div", { className: "".concat(classes || '') },
        React.createElement("div", { className: "hd-coverup fade-in" },
            React.createElement("div", { className: "tiers-pre-loader" },
                React.createElement("div", { className: "tiers-segment-spinner" })))));
};
export var SpinnerFull = function () {
    return React.createElement(Spinner, { classes: "tiers-spinner-fixed" });
};
